export const messages = {
  kidminStep1Title: {
    id: "auth-screen.kidmin.step-1-title",
    defaultMessage: "Step 1: Create a Bible Engagement Project Account",
  },
  kidminStep1Description: {
    id: "auth-screen.kidmin.step-1-description",
    defaultMessage:
      "A Bible Engagement Project account is needed to access your free resources.",
  },
  kidminStep2Title: {
    id: "auth-screen.kidmin.step-2-title",
    defaultMessage: "Step 2: Return to KidminRoadmap",
  },
  kidminStep1Disclaimer: {
    id: "auth-screen.kidmin.step-1-disclaimer",
    defaultMessage:
      "*Google and Apple Social Sign-in is unavailable at this time. Sign up using a traditional email/password.",
  },
  kidminStep2Description: {
    id: "auth-screen.kidmin.step-2-description",
    defaultMessage: "Login in and check out your strategy!",
  },
  kidminStep2Disclaimer: {
    id: "auth-screen.kidmin.step-2-disclaimer",
    defaultMessage:
      "*The login you create will be used for both accounts. Two Brands. One Account.",
  },
};
